module.exports = __webpack_public_path__ + "img/SchemaProtocoleNEC.8c926737.png";